// extracted by mini-css-extract-plugin
module.exports = {"box":"box-2jmjvXlB","ad":"ad-15lVKiCo"};